import initialState from './initialState';
import * as actions from '../actionTypes';

const reducer = (state = initialState.app, action) => {
    switch (action.type) {

        case actions.LOADING_OPERATION: {
            return {
                ...state,
                loading: action.payload
            }
        }

        case actions.FETCH_COMM_DATA: {
            return {
                ...state,
                communications: action.payload
            }
        }

        case actions.FETCH_COMM_DETAIL_DATA: {
            return {
                ...state,
                communication: action.payload
            }
        }

        case actions.FETCH_UNREAD_COMM: {
            return {
                ...state,
                unreadCommNum: action.payload
            }
        }

        default : 
            return {
                ...state
            }
    }
}

export default reducer;
